import { render, staticRenderFns } from "./AtalhoSimpleBtn.vue?vue&type=template&id=3668c280&scoped=true"
import script from "./AtalhoSimpleBtn.vue?vue&type=script&lang=js"
export * from "./AtalhoSimpleBtn.vue?vue&type=script&lang=js"
import style0 from "./AtalhoSimpleBtn.vue?vue&type=style&index=0&id=3668c280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3668c280",
  null
  
)

export default component.exports